function MoveSignup(selector) {
    var container = document.querySelector(selector || ".signup-container");
    if (!container) return;
    
    // First clean out the container
    container.innerHTML = "";

    var signup = document.querySelector(".signup");
    if (!signup) return;
    
    // Jam the sign up form into the empty container
    container.appendChild(signup);
}
